// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"i","newsroomBannerBox":"i","newsroomBannerLeft":"j","newsroomBannerRight":"k"};